import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const zoomMeetingsApiService = async () =>
  new JsonApiService("zoom_meetings", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

export const useZoomMeetingRecordings = () => {
  return {
    getZoomMeetingRecordings: async zoomMeetingId => {
      const service = await zoomMeetingsApiService();
      const response = await service
        .related(zoomMeetingId, "zoom_meeting_recordings")
        .then(response => response.json());
      return dataFormatter.deserialize(response);
    }
  };
};
